
import {
    POST_PROTOTYPING_UPLOAD_IMAGE,
    POST_PROTOTYPING_UPLOAD_IMAGE_SUCCESS,
    POST_PROTOTYPING_UPLOAD_IMAGE_FAILURE
} from './actionType';

// Reducer for Prototyping Upload Image

const initialState = {
    loading: false,
    data: [],
}

const Prototype = (state = initialState, action) => {
    switch (action.type) {
        case POST_PROTOTYPING_UPLOAD_IMAGE:
            return {
                ...state,
                loading: true
            }
        case POST_PROTOTYPING_UPLOAD_IMAGE_SUCCESS:
            return {
                ...state,
                loading: false,
                prototypeSuccess: action.payload
            }
        case POST_PROTOTYPING_UPLOAD_IMAGE_FAILURE:
            return {
                ...state,
                loading: false,
                prototypeFailure: action.payload
            }
        default:
            return state
    }
}

export default Prototype